import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'
import { OrganizationAction } from 'scenes/Dashboard/data/organizations/actions'
import { Organization, OrganizationMatchStatus } from 'scenes/Dashboard/data/organizations/types'

import { AddOrganizationModalAction } from '../components/AddOrganizationModal/duck/actions'

export const openDeletePopup = createAction(
  '/scenes/Dashboard/scenes/OrganizationManager/OPEN_DELETE_POPUP',
  (resolve) => (organizationId: Organization['id']) => resolve({ organizationId })
)

export const closeDeletePopup = createAction('/scenes/Dashboard/scenes/OrganizationManager/CLOSE_DELETE_POPUP')

export const getFilteredOrganizations = createAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/GET_FILTERED_ORGANIZATIONS'
)

export const updateCurrentPage = createAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/CHANGE_CURRENT_PAGE',
  (resolve) => (nextPage: number) => resolve({ nextPage })
)

export const updateSearch = createAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/UPDATE_SEARCH_QUERY',
  (resolve) => (search: string) => resolve({ search })
)

export const resetSearch = createAction('/scenes/Dashboard/scenes/OrganizationsManager/RESET_SEARCH')

export const dataExtraction = createAsyncAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/DATA_EXTRACTION_BEGIN',
  '/scenes/Dashboard/scenes/OrganizationsManager/DATA_EXTRACTION_SUCCESS',
  '/scenes/Dashboard/scenes/OrganizationsManager/DATA_EXTRACTION_FAILURE'
)<Organization['id'], Organization['id'], Error>()

export const checkOrganizationMatchStatus = createAsyncAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/MATCH_STATUS_BEGIN',
  '/scenes/Dashboard/scenes/OrganizationsManager/MATCH_STATUS_SUCCESS',
  '/scenes/Dashboard/scenes/OrganizationsManager/MATCH_STATUS_FAILURE'
)<Organization, { organization: Organization; status: OrganizationMatchStatus }, Error>()

export type OrganizationsManagerAction =
  | OrganizationAction
  | ActionType<
      | typeof openDeletePopup
      | typeof closeDeletePopup
      | typeof updateCurrentPage
      | typeof updateSearch
      | typeof getFilteredOrganizations
      | typeof dataExtraction
      | typeof resetSearch
      | typeof checkOrganizationMatchStatus
    >
  | AddOrganizationModalAction
